import * as Styles from './FinalScore.styles';

type FinalScoreType = {
  scoreLabel: string;
  resultLabel?: string;
};

export default function FinalScore({ scoreLabel, resultLabel }: FinalScoreType): JSX.Element {
  return (
    <Styles.Container>
      Final Score:
      <Styles.Score>
        {scoreLabel}
        {resultLabel && ` (${resultLabel})`}
      </Styles.Score>
    </Styles.Container>
  );
}
